import { MyAccountLayout } from "../../components/MyAccountLayout";
import { CommunicationPreferencesForm } from "../../components/CommunicationPreferencesForm";

export const MyAccountContactSettingsPage = () => {
  return (
    <MyAccountLayout page="contactSettings">
      <div className="flex flex-col col-span-5 gap-6">
        <CommunicationPreferencesForm />
      </div>
    </MyAccountLayout>
  );
};
